import { FunctionComponent, SVGAttributes } from 'react';

import {
  Ic911Menu,
  IcAnalytics,
  IcArrests,
  IcBuild,
  IcCall,
  IcEventList,
  IcFolderData,
  IcMarker,
  IcNote,
  IcPerson,
  IcJms,
  IcFire,
  IcSearch,
  IcSearchDoc,
  IcHeadsetMic,
} from '@/assets/images';

export interface ISideBarItem {
  key: string;
  label?: string;
  icon?: FunctionComponent<SVGAttributes<SVGAElement>>;
  link: string;
  items?: ISideBarItem[];
  submenuEl?: HTMLElement;
  setSubmenuEl?: React.Dispatch<React.SetStateAction<HTMLElement | undefined>>;
  isActive?: boolean;
  isDemoMode?: boolean;
}

export const FirstResponderItemsKeys = ['my-cfs', 'map-view'];

export const SidebarItems1: ISideBarItem[] = [
  {
    key: 'my-cfs',
    label: 'My CFS',
    icon: Ic911Menu,
    link: '/my-cfs',
  },
  {
    key: 'map-view',
    label: 'Map View',
    icon: IcMarker,
    link: '/map-view',
  },
  {
    key: 'admin',
    label: 'Admin',
    icon: IcPerson,
    link: '/admin',
  },
  {
    key: 'cfs',
    label: 'Call For Service',
    icon: IcCall,
    link: '/cfs',
  },
  {
    key: 'cfs-active',
    label: 'Active Dispatch Requests',
    icon: IcHeadsetMic,
    link: '/cfs-active',
  },
  {
    key: 'ncic-search',
    label: 'NCIC Search',
    icon: IcSearch,
    link: '/ncic-search',
  },
  {
    key: 'analytics',
    label: 'Analytics',
    icon: IcAnalytics,
    link: '/analytics',
    isDemoMode: true,
  },
  {
    key: 'kases',
    label: 'Cases',
    icon: IcNote,
    link: '/cases',
  },
  {
    key: 'fire-kases',
    label: 'Fire RMS',
    icon: IcFire,
    link: '/fire-cases',
  },
  {
    key: 'evidence',
    label: 'Evidence',
    icon: IcSearchDoc,
    link: '/evidence',
  },
  {
    key: 'master-index',
    label: 'Master Index',
    icon: IcFolderData,
    link: '/master-index',
  },
  {
    key: 'tasks',
    label: 'Tasks',
    icon: IcEventList,
    link: '/tasks',
  },
  {
    key: 'arrests',
    label: 'Arrests',
    icon: IcArrests,
    link: '/arrests',
  },
  {
    key: 'jms',
    label: 'Jail Management System',
    icon: IcJms,
    link: '/jms',
    items: [
      {
        key: 'operations',
        label: 'Operations',
        link: '/jms/operations',
        items: [
          {
            key: 'inmates-movement',
            label: 'Inmates Movement',
            link: '/jms/operations/inmates-movement',
          },
        ],
      },
      {
        key: 'management',
        label: 'Management',
        link: '/jms/management',
      },
    ],
  },
  {
    key: 'tools',
    label: 'Tools',
    icon: IcBuild,
    link: '/tools',
  },
];

export enum SwipeMotionDirection {
  Left = 'Left',
  Right = 'Right',
}

export const SwipeAnimates = {
  [SwipeMotionDirection.Left]: {
    initial: { x: '100%' },
    animate: { x: '0' },
  },
  [SwipeMotionDirection.Right]: {
    initial: { x: '-100%' },
    animate: { x: '0' },
  },
};
